export enum FormFieldType {
  None,
  Email,
  Text,
  Password,
  Group,
  MultiSelect,
  Checkbox
}
